/**
 * @fileoverview Agent definition for chapter-restructure-v1.
 *
 * Restructures a subset of unwritten chapters: split, merge, or reorganise
 * their narrative scope into a new set of chapter outlines.
 *
 * @category narrative.chapters.operations
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'chapter-restructure-v1',
  kind: 'primitive',
  name: 'Chapter Restructure',
  description: 'Restructures a subset of unwritten chapters: split, merge, or reorganise their narrative scope.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'narrative.chapters.operations',
    usedBy: [
      'primitives/use-chapter-restructure-v1.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'chapter-architect-v2',
      'chapter-architect-remaining-v2',
      'chapter-planner-v2',
      'chapter-splitter-v2',
    ],
  },
};
